import { useRef, useMemo } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'

export function Snowfall() {
  const pointsRef = useRef<THREE.Points>(null)
  
  const count = 1000
  
  // 生成雪花粒子
  const { positions, velocities } = useMemo(() => {
    const pos = new Float32Array(count * 3)
    const vel = new Float32Array(count)
    
    for (let i = 0; i < count; i++) {
      // 随机位置
      pos[i * 3] = (Math.random() - 0.5) * 40
      pos[i * 3 + 1] = Math.random() * 30
      pos[i * 3 + 2] = (Math.random() - 0.5) * 40
      
      // 随机下落速度
      vel[i] = 0.5 + Math.random() * 1.5
    }
    
    return { positions: pos, velocities: vel }
  }, [])
  
  // 动画更新
  useFrame((_, delta) => {
    if (!pointsRef.current) return
    
    const positionAttribute = pointsRef.current.geometry.getAttribute('position')
    const posArray = positionAttribute.array as Float32Array
    
    for (let i = 0; i < count; i++) {
      // 下落
      posArray[i * 3 + 1] -= velocities[i] * delta * 2
      
      // 轻微水平漂移
      posArray[i * 3] += Math.sin(Date.now() * 0.001 + i) * 0.01
      posArray[i * 3 + 2] += Math.cos(Date.now() * 0.001 + i) * 0.01
      
      // 重置到顶部
      if (posArray[i * 3 + 1] < -2) {
        posArray[i * 3 + 1] = 30
        posArray[i * 3] = (Math.random() - 0.5) * 40
        posArray[i * 3 + 2] = (Math.random() - 0.5) * 40
      }
    }
    
    positionAttribute.needsUpdate = true
  })
  
  return (
    <points ref={pointsRef}>
      <bufferGeometry>
        <bufferAttribute
          attach="attributes-position"
          count={count}
          array={positions}
          itemSize={3}
        />
      </bufferGeometry>
      <pointsMaterial
        size={0.1}
        color="#ffffff"
        transparent
        opacity={0.8}
        sizeAttenuation
        depthWrite={false}
      />
    </points>
  )
}